import type { IntlShape } from 'react-intl'
import { useIntl } from '@/intl'
import { Typography } from '@sunwebgroup/ui-components'
import { ServiceType } from '../domain/types'

export function getServiceName(type: string, intl: IntlShape): string | undefined {
  const nameMappings: [string[], string][] = [
    [[ServiceType.CarRental, 'AUTOHUUR*'], 'checkout_steps_ancillaries_car_rental_title'],
    [[ServiceType.CarRentalFiltering], 'checkout_steps_ancillaries_car_rental_filtering_title'],
    [
      [ServiceType.TravelInsurance, ServiceType.TravelInsurancePerBooking, 'TRAVEL*'],
      'checkout_steps_ancillaries_travel_insurance_title',
    ],
    [
      [ServiceType.CancellationInsurance, ServiceType.CancellationInsurancePerBooking, 'CANCEL*'],
      'checkout_steps_ancillaries_cancellation_insurance_title',
    ],
    [[ServiceType.MealplanDP, 'ACCOMMODATION'], 'checkout_steps_ancillaries_mealplan_dp_title'],
    [[ServiceType.Mealplan, 'VERZORGING*'], 'checkout_steps_ancillaries_mealplan_title'],
    [[ServiceType.MealplanExternal, 'HALFBOARD*'], 'checkout_steps_ancillaries_mealplan_external_title'],
    [[ServiceType.Breakfast, 'BREAKFAST'], 'checkout_steps_ancillaries_breakfast_title'],
    [[ServiceType.BreakfastArrivalBus, 'BREAKFARRHINT_00'], 'checkout_steps_ancillaries_breakfast_arrival_bus_title'],
    [[ServiceType.Dinner, 'DINNER'], 'checkout_steps_ancillaries_dinner_title'],
    [[ServiceType.BookingRedeem, 'REDEEM'], 'checkout_steps_ancillaries_booking_redeemer_title'],
    [[ServiceType.Luggage, 'LUG_*'], 'checkout_steps_ancillaries_luggage_title'],
    [[ServiceType.DutchweekValThorens, 'DUTCHWEEK1'], 'checkout_steps_ancillaries_dutchweek_val_thorens_title'],
    [[ServiceType.Dutchweek, 'DUTCHWEEK'], 'checkout_steps_ancillaries_dutchweek_title'],
    [[ServiceType.Comedy, 'COMEDY'], 'checkout_steps_ancillaries_comedy_title'],
    [
      [ServiceType.SkiTransfer, ServiceType.SkiTransferPerBooking, 'SHAREDBUS'],
      'checkout_steps_ancillaries_ski_transfer_title',
    ],
    [[ServiceType.SkiCarriage, 'CARRIAGESKI*'], 'checkout_steps_ancillaries_ski_carriage_title'],
    [[ServiceType.PartyTickets, 'PARTY'], 'checkout_steps_ancillaries_party_tickets_title'],
    [[ServiceType.SkiPass], 'checkout_steps_ancillaries_ski_pass_title'],
    [[ServiceType.SkiMaterial], 'checkout_steps_ancillaries_ski_material_title'],
    [[ServiceType.SkiLesson], 'checkout_steps_ancillaries_ski_lesson_title'],
    [[ServiceType.Sweater, 'SWEATER*'], 'checkout_steps_clothing_sweater_title'],
    [[ServiceType.TShirt, 'TSHIRT*'], 'checkout_steps_clothing_tshirt_title'],
    [[ServiceType.Bus, 'BUS'], 'checkout_steps_ancillaries_bus_title'],
    [[ServiceType.Golf, 'GREENFEE'], 'checkout_steps_ancillaries_golf_title'],
    [[ServiceType.DinnerVouchers, 'MEAL-VOUCHERS'], 'checkout_steps_ancillaries_dinner_vouchers_title'],
    [[ServiceType.Bridge, 'BRIDGE'], 'checkout_steps_ancillaries_bridge_title'],
  ]

  for (const [types, messageId] of nameMappings) {
    if (types.includes(type)) {
      return intl.formatMessage({ id: messageId })
    }
  }

  return undefined
}

export function ServiceName({ type }: { type: string }) {
  const intl = useIntl()
  const name = getServiceName(type, intl)

  return (
    <Typography $variant="body-md">
      {' '}
      {name}
      {' '}
    </Typography>
  )
}
